import { render, staticRenderFns } from "./AwardWinningGridItem.vue?vue&type=template&id=3ce4b0f3&"
import script from "./AwardWinningGridItem.vue?vue&type=script&lang=js&"
export * from "./AwardWinningGridItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports